import shipvistaAPI from "./shipvistaAPI";

export const redeemPromoCode = (data) => {
  return shipvistaAPI.post(`/promoCodes/ApplyCode`, data);
};
